/* eslint no-template-curly-in-string: 0 */
import { ModelManager } from '@felicity/data-management';
import { Tooltip } from '@syncfusion/ej2-popups';
import { Toast } from '@syncfusion/ej2-notifications';
import { Grid, Resize, Page } from '@syncfusion/ej2-grids';
import Profile from '../models/Profile.mjs';
import ProfileEditor from './ProfileEditor.mjs';

/**
 * Model manager for identity profiles
 */
export default class ProfileManager extends ModelManager {
  constructor() {
    super(Profile, ProfileEditor);
  }

  connectedCallback() {
    super.connectedCallback();

    const resetPasswordButton = this.grid.toolbarModule.toolbar.items[3];
    this.grid.addEventListener('dataBound', (e) => {
      resetPasswordButton.disabled = true;
    });
    this.grid.addEventListener('rowSelected', (e) => {
      resetPasswordButton.disabled = false;
    });
    this.grid.addEventListener('rowDeselected', (e) => {
      resetPasswordButton.disabled = true;
    });
  }

  sendPasswordResetEmail(userId) {
    fetch(`/api/Users/Profile/SendPasswordResetEmail/${userId}`)
      .then((response) => response.json())
      .then((json) => {
        const toast = new Toast({
          title: this.phrase('resetPassword.success', 'message', 'profileManager'),
          content: json.message,
          position: { X: 'Right', Y: 'Top' },
          width: 250,
        });
        toast.appendTo('#notifications');
        toast.show({
          timeOut: 3000
        });
      });
  }

  _initGrid() {
    Grid.Inject(Resize, Page);

    return super._initGrid({
      toolbar: [
        'Add', 'Delete',
        { type: 'Separator' },
        {
          id: 'reset-password',
          prefixIcon: 'fas fa-lock',
          cssClass: 'icon-only',
          click: (e) => {
            const records = this.grid.getSelectedRecords();
            if (records.length) {
              this.sendPasswordResetEmail(records[0].id);
            }
          },
          disabled: true,
          tooltipText: this.phrase('resetPassword.tooltip', 'action', 'profileManager')
        },
        'Search'
      ],
      columns: [
        { commands: this._crudCommands(), width: 110 },
        {
          field: 'id',
          headerText: 'Id',
          width: 60,
          isPrimaryKey: true,
          template: `
            <button class="copy-id e-btn e-flat e-small">
              <i class="fas fa-copy"></i>
            </button>`
        },
        // {
        //   field: 'picture',
        //   headerText: 'Picture',
        //   width: 100,
        //   template: `
        //     \${if(picture)}
        //     <img src="\${picture}" alt="\${name}" class="e-avatar e-avatar-small
        // e-avatar-circle">
        //     \${else}
        //     <i class="fas fa-user"></i>
        //     \${/if}`
        // },
        {
          field: 'name',
          headerText: this.phrase('name', 'profile', 'model'),
          width: '100%'
        },
        {
          field: 'organisationName',
          headerText: this.phrase('organisationName', 'profile', 'model'),
          width: 200
        },
        {
          field: 'email',
          headerText: this.phrase('email', 'profile', 'model'),
          width: 200,
          template: '<a href="mailto:${email}">${email}</a>'
        },
        {
          field: 'emailConfirmed',
          headerText: this.phrase('emailConfirmed', 'column', 'profileManager'),
          width: 120,
          textAlign: 'center',
          template: '${if(emailConfirmed)}<span class="e-icons e-check"></span>${else}${/if}'
        },
        {
          field: 'roles',
          headerText: this.phrase('roles', 'profile', 'model'),
          width: 160
        }
      ],

      sortSettings: { columns: [{ field: 'name', direction: 'Ascending' }] },

      allowGrouping: false,
      // groupSettings: { showDropArea: false, columns: ['roles'] },

      allowResizing: true,
      allowPaging: true,

      created: () => {
        new Tooltip({
          target: '.e-toolbar .icon-only[title]',
          position: 'TopCenter'
        }).appendTo(this);
      },

      queryCellInfo: (e) => {
        if (e.column.field === 'id') {
          e.cell.querySelector('.copy-id')
            .addEventListener('click', (be) => {
              const tr = be.target.closest('.e-row'),
                dataItem = this.grid.getRowInfo(tr).rowData;
              if (dataItem) {
                navigator.clipboard.writeText(dataItem.id);
                this.trigger('copy.clipboard');
              }
            });
        }
      }
    });
  }
}

ProfileManager.register('profile-manager');
